import { FC } from 'react'
import { formatCurrency } from 'lib/helpers'

type DonationTagProps = {
  amount: number
  className?: string
}

export const DonationTag: FC<DonationTagProps> = ({
  amount,
  className = '',
}) => {
  if (!amount) return null
  return (
    <div
      className={`${className} inline-flex items-center rounded-8 bg-yellow px-10 py-12 pr-14 text-12 leading-110 text-darkGray`}
    >
      <div className="mr-6 h-8 w-8 rounded-full bg-darkGray"></div>
      <span>{formatCurrency(amount)} Donated</span>
    </div>
  )
}
